import {Component, NgModule} from '@angular/core';
import {QRCodeComponent} from "angular2-qrcode";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['app.component.css']


})


export class AppComponent {
  title = 'SRVPLS !!!';


  constructor(){
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts